import React, { useContext } from "react";
import { Accordion, Button, Loading, TitleBar, useGetUserFarmerIds } from "modules/common";
import {
    useGetEducationsByTitlesAndCounty,
    useGetFarmerObligations,
} from "modules/common/hooks/dippHooks";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "routing";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    oib: string;
    county?: string;
}

export const MeasuresEducations: React.FC<Props> = ({ oib, county }) => {
    const { data: farmerIds, isFetching: isLoading } = useGetUserFarmerIds(oib);
    const { data: obligations, isFetching: isLoadingObligations } = useGetFarmerObligations(farmerIds);
    const { fontSize } = useContext(AccessibilityContext);
    const educationNames = React.useMemo(
        () =>
            obligations
                ? obligations.farmerObligations.map(obligation => obligation.educationName)
                : [],
        [obligations]
    );
    const { data: educations, isFetching: isLoadingEducations } = useGetEducationsByTitlesAndCounty(educationNames, county);
    const history = useHistory();

    return (
        <div>
            <TitleBar>
                <TitleBar.Left>
                    <span className="title-bar-text profile-title" style={{ fontSize: `${fontSize}%` }}>MJERE I TEČAJEVI</span>
                </TitleBar.Left>
            </TitleBar>
            {(isLoading || isLoadingEducations || isLoadingObligations) && <Loading size="small" />}
            {obligations && obligations.farmerObligations.length > 0 ? (
                Object.values(obligations.farmerObligations).map(obligation => (
                    <Accordion
                        key={obligation.educationName}
                        title={`${obligation.educationName} (${obligation.entryYear}), Status: ${
                            obligation.done ? "Završeno" : "Nije završeno"
                        }`}
                        className="measuresEducations-accordion"
                        isButtonWithBorder
                    >
                        <ul className="educationTitles-list">
                            {educations &&
                            Object.values(educations.educations[obligation.educationName]).length >
                                0 ? (
                                Object.values(educations.educations[obligation.educationName]).map(
                                    educationTitles => (
                                        <li key={educationTitles.title}>{educationTitles.title}</li>
                                    )
                                )
                            ) : (
                                <div className="no-educations">Nema dostupnih edukacija</div>
                            )}
                        </ul>
                    </Accordion>
                ))
            ) : (
                <div className="no-obligations">Nema obaveza</div>
            )}
            <div className="my-educations-row">
                <Button
                    type="button"
                    variant="primary"
                    size="small"
                    onClick={() => history.push(AppRoutes.Education)}
                >
                    Moje edukacije
                </Button>
            </div>
        </div>
    );
};
